/**
 * Адрес API и WebSocket (dev — по hostname, prod — из env).
 */

const DEV_SERVER_PORT = 3010;
const API_PATH = '/api';

const isDev = import.meta.env.DEV;

function getServerHost(): string {
  const currentUrl = window.location;
  if (currentUrl.hostname !== 'localhost' && currentUrl.hostname !== '127.0.0.1') {
    return currentUrl.hostname;
  }
  return 'localhost';
}

export const getServerUrl = (): string => {
  const host = getServerHost();
  return `http://${host}:${DEV_SERVER_PORT}`;
};

export const getApiBaseUrl = (): string => {
  const host = getServerHost();
  return `http://${host}:${DEV_SERVER_PORT}${API_PATH}`;
};

const getProductionOrigin = (): string => window.location.origin.replace(/\/$/, '');

/** База HTTP API (включает суффикс `/api`). */
export const API_BASE_URL = isDev
  ? getApiBaseUrl()
  : (import.meta.env.VITE_API_BASE_URL as string) || `${getProductionOrigin()}${API_PATH}`;

/** Origin сервера для Socket.IO (без path; клиент использует path `/socket.io`). */
export const SOCKET_URL = isDev
  ? getServerUrl()
  : (import.meta.env.VITE_SOCKET_URL as string) || getProductionOrigin();

/** Потоковый чат AI (`DefaultChatTransport`). */
export const API_CHAT_URL = `${API_BASE_URL.replace(/\/$/, '')}/chat`;

if (isDev) {
  console.log('🔧 Dev mode enabled');
  console.log('📡 API_BASE_URL:', API_BASE_URL);
  console.log('🔌 SOCKET_URL:', SOCKET_URL);
}
